<template>
    <div>
        <div v-if="authUserPermission['tasks-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">{{ tt('tasks') }}</h3>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_tasks')" v-on:keyup="filter"/>                            
                                </div>
                            </div>
                            <div class="col text-right">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['tasks-create']">{{ tt('add_new') }}</base-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('code')" :prop="tt('code')" sortable>
                                <template v-slot="{row}">
                                    {{row.tasks_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('task')" :prop="tt('task')" sortable>
                                <template v-slot="{row}">
                                    {{row.task}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('source_type')" :prop="tt('source_type')" sortable>
                                <template v-slot="{row}">
                                    {{row.source_type}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('source')" :prop="tt('source')" sortable>
                                <template v-slot="{row}">
                                    {{row.source}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('description')" :prop="tt('description')" sortable>
                                <template v-slot="{row}">
                                    {{row.description}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true" v-if="authUserPermission['tasks-update'] || authUserPermission['tasks-delete']">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}" v-if="authUserPermission['tasks-update']">Edit</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}" v-if="authUserPermission['tasks-delete']">Delete</el-dropdown-item>                                   
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>

                        <label class="form-control-label">{{ tt('code') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('code')" :placeholder="tt('code')" v-model="tasks.tasks_code" rules="required|max:50"></base-input>

                        <label class="form-control-label">{{ tt('task') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('task')" :placeholder="tt('task')" v-model="tasks.task" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('source_type') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('source_type')" rules="required">
                            <el-select class="select-danger" v-model="tasks.source_type" placeholder="Choose Source Type">
                                <el-option class="select-danger" value="table-column" label="Table Column" key="Table Column"></el-option>
                                <el-option class="select-danger" value="query" label="Query" key="Query"></el-option>
                            </el-select>
                        </base-input>

                        <div v-if="tasks.source_type == 'table-column'">
                            <label class="form-control-label">{{ tt('table_column') }} <span class="text-danger">*</span></label>
                            <base-input :name="tt('table_column')" rules="required">
                                <el-select class="select-danger" v-model="tasks.source" :placeholder="tt('choose_source')">
                                    <el-option class="select-danger" :value="tc['table_column_code']" :label="tc['table_column_code'] + ' - ' + tc['table']" :key="tc['table_column_code'] + ' - ' + tc['table']" v-for="tc in  tableColumn">{{ tc['table_column_code'] }} - {{ tc['table'] }}</el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div v-else-if="tasks.source_type == 'query'">
                            <label class="form-control-label">{{ tt('query') }} <span class="text-danger">*</span></label>
                            <base-input :name="tt('query')" rules="required">
                                <textarea class="form-control" placeholder="select * from company where id = {$key}" rows="3" v-model="tasks.source"></textarea>
                            </base-input>
                        </div>

                        <label class="form-control-label">{{ tt('view_target') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('view_target')" :placeholder="tt('view_target')" v-model="tasks.view_target" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('view_url') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('view_url')" :placeholder="tt('view_url')" v-model="tasks.view_url" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('process_target') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('process_target')" :placeholder="tt('process_target')" v-model="tasks.process_target" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('process_url') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('process_url')" :placeholder="tt('process_url')" v-model="tasks.process_url" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('duration') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('duration')" :placeholder="tt('duration')" v-model="tasks.duration" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('description') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('description')" :placeholder="tt('description')" v-model="tasks.description" rules="required"></base-input>
                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import tasks from '@/services/setting/tasks.service';
    import tableColumn from '@/services/setting/tableColumn.service';

    export default {        
        data() {
            return {                 
                onLoad: true,      
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },             
                form: {
                    add: true,
                    title: this.tt('add_mail_templates'),
                    show: false
                }, 
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: {
                        current_page: 1,
                        per_page: 100,
                    },
                },     
                errorMessage: null,   
                tasks: {},
                tableColumn: {},
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
            this.getTableColumn()
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, tasks.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data;  
                    context.holdingCode = response.data.data.client;
                    context.table.page  = response.data.data.data;
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            getTableColumn() {
                let context = this;               
                Api(context, tableColumn.get({per_page: 'none'})).onSuccess(function(response) {    
                    context.tableColumn = response.data.data.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.tableColumn = [];
                    }
                })
                .call()
            },
            filter() {
                this.onLoad = true;
                this.table.page.current_page = 1;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_task');
                this.form.show = true;
                this.tasks = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, tasks.show(id)).onSuccess(function(response) {
                    context.tasks = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('edit_task');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, tasks.create(this.tasks));
                } else {{
                    api = Api(context, tasks.update(this.tasks.id, this.tasks));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, tasks.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        }   
    };
</script>
<style></style>
